module.exports = __webpack_public_path__ + "static/media/close-icon.adb05711.svg";